<template>
    <div :class="{ inverted: dark }" id="main-container">
        <VueZoomable v-if="url" selector="#divId" :minZoom="0.1" :maxZoom="10" :dblClickZoomStep="3" v-model:zoom="zoom"
            v-model:pan="pan" class="vue-zoomable-container">
            <div id="divId">
                <div v-if="file_extension == 'svg'" class="image-wrapper svg-wrapper">
                    <InlineSvg :src="url" class="svg-content" />
                </div>
                <v-img v-else class="image-wrapper" :src="url" contain></v-img>
            </div>
            <template v-slot:buttons>
                <span></span>
            </template>
        </VueZoomable>
    </div>
</template>


<style lang="scss" scoped>
.inverted {
    filter: invert(64%) contrast(228%) brightness(80%) hue-rotate(180deg);
}


#main-container {
    position: relative;
    height: 100%;
    width: 100%;
}

.vue-zoomable-container {
    height: 100%;
    width: 100%;
}

#divId {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.image-wrapper {
    width: 100%;
    height: 100%;
}

.svg-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.svg-content {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
}
</style>

<script>
import InlineSvg from "vue-inline-svg";
import "vue-zoomable/dist/style.css";
import VueZoomable from "vue-zoomable";
import { useZoomableTouchCleanup } from "@/composables/zoomable";


export default {
    name: "PictureView",
    components: {
        InlineSvg,
        VueZoomable,
    },
    setup() {
        useZoomableTouchCleanup()
    },
    props: {
        url: String,
    },
    data: () => ({
        zoom: 1,
        pan: { x: 0, y: 0 },
    }),
    computed: {
        dark() {
            return this.$vuetify.theme.global.current.dark;
        },
        file_extension() {
            try {
                return this.url
                    .split(/[#?]/)[0]
                    .split(".")
                    .pop()
                    .trim()
                    .toLowerCase();
            } catch (e) {
                return null;
            }
        },
    },
    methods: {
        recenter() {
            console.log("[>] Recentering picture.");
            this.zoom = 1
            this.pan = { x: 0, y: 0 }
        },
        modifySvg(svg) {
            svg.removeAttribute('width');
            svg.removeAttribute('height');
            svg.setAttribute('preserveAspectRatio', 'xMidYMid meet'); // Ensures centering and ratio preservation
            return svg;
        },
    },
};
</script>
